import React, { useMemo, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Stack, Typography } from "@mui/material";

import { State } from "./CreateReportSection";
import { Table } from "./Table";

interface Props {
  data: State["table"];
  onSubmit: (data: State["table"]) => void;
  onCancel: () => void;
}

export const EditTable: React.FC<Props> = ({ onCancel, data, onSubmit }) => {
  const [state, setState] = useState<Props["data"]>(data);

  const isDisabledSubmit = useMemo(() => {
    return !state.name || !state.group_by.length;
  }, [state]);

  return (
    <Stack
      sx={{
        outline: "none",
        bgcolor: "white",
        minWidth: 300,
        p: "32px",
        gap: "20px",
        borderRadius: "8px",
        borderShadow: "sm",
        maxHeight: "500px",
        overflow: "hidden"
      }}
    >
      <Stack sx={{ flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #DBE8F5" }}>
        <Typography sx={{ fontSize: "18px", fontWeight: 400, lineHeight: "24px" }}>Table</Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Stack sx={{ overflow: "auto", pt: "6px" }}>
        <Table data={state} setData={setState} />
      </Stack>
      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "8px" }}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => onSubmit(state)} disabled={isDisabledSubmit}>
          Confirm
        </Button>
      </Stack>
    </Stack>
  );
};
